import {
  TLogoutRequestSchema,
  TLogoutResponseSchema,
} from "./logout.jsonschema";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const logout = (axios: IAxiosInstance) => {
  return async ({
    keepPrimary,
    keepSession,
    refreshToken,
  }: TLogoutRequestSchema) => {
    const response = await axios.noRetry.post<TLogoutResponseSchema>(
      `/logout`,
      {
        keepPrimary,
        keepSession,
        refreshToken,
      }
    );
    const data = response.data;

    return data;
  };
};
